import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { AnimatedGroup } from "@/components/ui/animated-group";
import { cn } from "@/lib/utils";
import {
  Section,
  SectionContainer,
  SectionHeader,
  SectionTitle,
  SectionContent,
} from "@/components/ui/section";

const questions = [
  {
    id: "question-1",
    question: "How long does it take to build a website?",
    answer: [
      "It depends on the project scope. A simple site can be ready in 2–3 weeks, while more complex projects take several months.",
    ],
  },
  {
    id: "question-2",
    question: "Can I edit my website after it’s built?",
    answer: [
      "Yes! We integrate CMS solutions so you can easily manage content without coding knowledge.",
    ],
  },
  {
    id: "question-3",
    question: "Do you provide hosting and website maintenance?",
    answer: [
      "Yes, we offer technical support, performance optimization, and ongoing updates.",
    ],
  },
  {
    id: "question-4",
    question: "Will my website rank well on Google?",
    answer: [
      "Absolutely! We ensure fast loading speeds, SEO-friendly structure, and content optimization for better search engine rankings.",
    ],
  },
  {
    id: "question-5",
    question: "What technologies do you use?",
    answer: [
      "We work with a modern tech stack – React, Next.js, Tailwind, Node.js, as well as e-commerce platforms like Shopify and WooCommerce.",
    ],
  },
];

const Faq = () => {
  return (
    <Section id="faq">
      <SectionContainer>
        <SectionHeader>
          <SectionTitle>FAQ</SectionTitle>
        </SectionHeader>
        <SectionContent>
          <Accordion type="single" defaultValue="question-1">
            <AnimatedGroup className="grid gap-2 md:gap-4">
              {questions.map(({ id, question, answer, className }, index) => (
                <AccordionItem key={id} value={id} className={cn(className)}>
                  <AccordionTrigger className="text-start">
                    {question}
                  </AccordionTrigger>
                  <AccordionContent>
                    {answer.map((paragraph, index) => (
                      <p key={index} className="mb-4">
                        {paragraph}
                      </p>
                    ))}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </AnimatedGroup>
          </Accordion>
        </SectionContent>
      </SectionContainer>
    </Section>
  );
};

export default Faq;
